import { inject, Injectable } from '@angular/core'

import { LanguageCode } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { LanguageService } from '@ti/core/ui-kit/i18n'

@Injectable()
export class FleetLanguageService extends LanguageService {
  protected readonly api = inject(ApiService)
  protected override async saveCurrentUserLanguage(language: LanguageCode) {
    if (await this.authSession.isLoggedIn()) {
      await this.api.fleet.user.setLanguage(language)
    }
  }
}
